module.exports = __webpack_public_path__ + "img/good-2.c17ffe51.png";